import { LoginSelector } from "store/data/User";
import { atom } from "recoil";
import { selectorWithoutCache as selector } from "util/RecoilWithoutCache";
import { MixContractTickerInfo, MixSpotTickerInfo } from "../entity";
import {
  ALERT_TYPE,
  OPERATION_TYPE,
  PRICE_TYPE,
  TRADE_TYPE,
} from "components/Drawers/PriceAlert/enums/priceAlertEnum";
import { getAlertLogListApi } from "api/ct/priceAlert";
import { UserPreferenceSetting } from "./User";
import { isNil } from "lodash-es";

export type MixSelectTickerType = {
  [x: string]: any;
  symbolId: string;
  /**市场价格 */ //尽量不要使用价格作为依赖，因为价格会变化，会导致重复触发
  price: number;
  /**标记价格 */
  markPrice: number;
  chgUTC: number;
  symbolCode: string;
  symbolType: number;
  deliveryStatusEnum: number;
  deliveryPrice: number;
  deliveryStartTime: string;
  deliveryTime: string;
  businessLine: number;
  isFavorite: boolean;
  get: any;
  before24Open: string;
};

export type SelectUperType = {
  [key: string]: MixSelectTickerType;
};

export type SelectDownType = {
  [key: string]: MixSelectTickerType;
};

export type SelectPercentType = {
  [key: string]: MixSelectTickerType;
};

export interface SpotAllTickersSelectorType {
  [x: string]: any;
  all?: MixSpotTickerInfo[];
}

export type PriceAlertUserPreference = {
  priceAlarmDesktopPop: number;
  priceAlarmDesktopVoice: number;
};
export type FrequencyParameter = {
  /** 每秒 */
  inSecond: number;
  /** 每分钟/次 */
  frequencys: number;
  /** 每小时/次 */
  perHour: number;
  /** 每24小时/次 */
  perDay: number;
  /** 业务线配置数 */
  businessLineLimit: number;
  /** 总配置数 */
  totalLimit: number;
};

export const DropDownListState = atom<SpotAllTickersSelectorType>({
  key: "drop-down-list-state",
  default: {},
});
/**
 * 当前选中的ticker
 */
export const MixSelectTicker = selector<MixSelectTickerType>({
  key: "ticker-select-values-get",
  get: ({ get }) => {
    const EditDatas = get(EditData);
    const curOptionType = get(optionType);
    let tickerSelct = get(SelectTicker); // 当前选中的ticker
    const ChooseTypes = get(SelecedTradeType);
    let allData = [];
    if (ChooseTypes === TRADE_TYPE.FUTURES) {
      const { all } = get(FutureAllTickersSelector);
      allData = all || [];
    } else {
      const { all } = get(SpotAllTickersSelector);
      allData = all || [];
    }

    if (!tickerSelct?.symbolId) {
      //编辑 当前选中的ticker
      if (curOptionType === OPERATION_TYPE.EDIT) {
        if (allData?.length > 0) {
          const findSelect = allData.find(
            (item) => item.symbolId === EditDatas?.exchangeId
          );
          tickerSelct = findSelect;
        }
      }
      if (curOptionType === OPERATION_TYPE.ADD) {
        //修改现货｜合约默认选中Ticker  默认为BTCUSDT
        const BTCUSDT = "BTCUSDT";
        tickerSelct = allData.find((item) => item.symbolCode === BTCUSDT);
      }
    }

    return tickerSelct || {};
  },
  set: ({ set }, state) => {
    set(SelectTicker, state);
  },
});

/**
 *  当前选中的ticker的价格（市场价格｜标记价格）
 */
export const MixSelectTickerPrice = selector({
  key: "ticker-select-price",
  get: ({ get }): number => {
    const tradeType = get(SelecedTradeType);
    const tickerSelct = get(MixSelectTicker);
    const priceType = get(SelectedPriceType);
    let price = 0;
    if (tradeType === TRADE_TYPE.SPOT) {
      price = tickerSelct?.price;
    } else {
      if (priceType === PRICE_TYPE.MARKET) {
        price = tickerSelct?.price;
      }
      if (priceType === PRICE_TYPE.MARK) {
        price = tickerSelct?.markPrice;
      }
      if (priceType === PRICE_TYPE.INDEX_PRICE) {
        price = tickerSelct?.indexPrice;
      }
      // price = priceType === PRICE_TYPE.MARKET ? tickerSelct?.price : tickerSelct?.markPrice
    }
    return isNil(price) ? 0 : +price;
  },
});

/** 交易类型  现货1 合约2 */
export const SelecedTradeType = atom<TRADE_TYPE>({
  key: "select-ticker-item",
  default: TRADE_TYPE.FUTURES,
});

// 合约 现货 收藏列表
export const allStartList = atom<{ symbolId: string; symbolCode: string }[]>({
  key: "all-start-list",
  default: [
    {
      symbolId: "BTCUSDT_UMCBL",
      symbolCode: "BTCUSDT",
    },
    {
      symbolId: "ETHUSD_DMCBL",
      symbolCode: "ETHUSD",
    },
  ],
});

export const allStarSetSelector = selector<Set<string>>({
  key: "all-star-set-selector",
  get: ({ get }) => {
    return new Set(get(allStartList).map((item) => item.symbolId));
  },
});

/**
 * 所有 合约 Ticker数据
 */
export const FutureAllTickersState = atom<MixContractTickerInfo[]>({
  key: "all-tickers-state",
  default: [],
});
// 所有合约  ticker 的 set get方法
export const FutureAllTickersSelector = selector<any>({
  key: "all-tickers-selector",
  get: ({ get }) => {
    // 用户收藏的
    const startLists = get(allStartList);
    const startMap = {};
    startLists.forEach((item) => {
      if (!startMap[item.symbolId]) {
        startMap[item.symbolId] = item.symbolId;
      }
    });
    // 所有 合约 ticker
    const contractAllTickersStates = get(FutureAllTickersState);
    let isSelected = [] as MixContractTickerInfo[];
    let typeMap = {
      all: [],
    } as {
      [key: string]: MixContractTickerInfo[];
    };
    contractAllTickersStates.forEach((item) => {
      let itemTmp = {
        ...item,
        isFavorite: !!startMap[item.symbolId],
      };
      if (startMap[item.symbolId]) {
        isSelected.push({ ...itemTmp });
      }
      if (typeMap[item.businessLine]) {
        typeMap[item.businessLine].push({ ...itemTmp });
      } else {
        typeMap[item.businessLine] = [{ ...itemTmp }];
      }
      typeMap.all.push({ ...itemTmp });
    });

    return {
      isSelected,
      ...typeMap,
    };
  },
  set: ({ set }, tickers: MixContractTickerInfo[]) => {
    set(FutureAllTickersState, tickers);
  },
});
/***新增编辑类型 */
export const optionType = atom<any>({
  key: "ticker-option-key",
  default: "add",
});

/** 价格提醒弹框表单 编辑数据 */
export const EditData = atom<any>({
  key: "alert-edit-data",
  default: {},
});

/**
 * 默认选中的ticker
 */
export const SelectTicker = atom<any>({
  key: "ticker-select-values",
  default: {
    symbolId: "",
    markPrice: 0,
    chgUTC: 0,
    price: 0,
    leftCoinName: "",
    rightCoinName: "",
    exchangeName: "",
    tabCoin: 10,
  },
});

/**
 * 所有业务线现货
 */
export const SpotAllTickersState = atom<MixSpotTickerInfo[]>({
  key: "all-ticker-spot-state",
  default: [],
});
// 所有现货  ticker 的 set get方法
export const SpotAllTickersSelector = selector<any>({
  key: "all-tickers-spot-selector",
  get: ({ get }) => {
    // 用户收藏的
    const startMap = {};
    const SpotAllTickersStates = get(SpotAllTickersState);
    let isSelected = [] as MixSpotTickerInfo[];
    let typeMap = {
      all: [] as MixSpotTickerInfo[],
    };
    SpotAllTickersStates.forEach((item) => {
      let itemTmp = {
        ...item,
        isFavorite: item.isSelected,
      };
      if (startMap[item.pricedSymbol]) {
        if (item.isSelected) isSelected.push({ ...itemTmp });
      }
      if (typeMap[item.pricedSymbol]) {
        typeMap[item.pricedSymbol].push({ ...itemTmp });
      } else {
        typeMap[item.pricedSymbol] = [{ ...itemTmp }];
      }
      typeMap.all.push({ ...itemTmp });
    });
    return {
      isSelected,
      ...typeMap,
    };
  },
  set: ({ set }, tickers: MixSpotTickerInfo[]) => {
    set(SpotAllTickersState, tickers);
  },
});
/**
 * 选择的合约精度
 */
export const SelectFuturePoint = atom<number>({
  key: "select-point-state",
  default: 2,
});

//选择的现货精度
export const selectSpotPoint = atom<number>({
  key: "select-point-state-spot",
  default: 2,
});

/** 选中的消息提醒类型 */
export const SelectAlertType = atom<ALERT_TYPE>({
  key: "select-alert-type",
  default: ALERT_TYPE.ONE,
});

/**
 * 选中的价格类型 市场价格｜标记价格
 *
 */
export const SelectedPriceType = atom<PRICE_TYPE>({
  key: "selct-markeType-key",
  default: PRICE_TYPE.MARKET,
});
/**
 * 滑杆input 的值
 */
export const SliderValuePut = atom<number>({
  key: "slect-price-slider",
  default: 0,
});

/**
 * 当前滑杆的值
 */
export const SelectSlider = selector<any>({
  key: "slider-select-values",
  get: ({ get }) => {
    let sliderVal = get(SliderValuePut);
    const defaultVal = get(MixSelectTicker);
    const chooseType = get(SelecedTradeType);
    const priceType = get(SelectedPriceType);
    const EditDatas = get(EditData);
    const type = get(optionType);
    //默认值
    if (sliderVal == null) {
      if (type === OPERATION_TYPE.ADD) {
        //合约 0市场价 1限价
        if (chooseType === TRADE_TYPE.FUTURES) {
          if (priceType === PRICE_TYPE.MARKET) {
            sliderVal = defaultVal?.price;
          }
          if (priceType === PRICE_TYPE.MARK) {
            sliderVal = defaultVal?.markPrice;
          }
          if (priceType === PRICE_TYPE.INDEX_PRICE) {
            sliderVal = defaultVal?.indexPrice;
          }
          // sliderVal = priceType === PRICE_TYPE.MARKET ? defaultVal?.price : defaultVal?.markPrice
        } else {
          //现货只有市场价格
          sliderVal = defaultVal?.price;
        }
      } else {
        //编辑
        sliderVal = EditDatas?.configurePrice;
      }
      //有问题显示数字

      return isNil(sliderVal) ? 0 : +sliderVal;
    } else {
      return get(SliderValuePut);
    }
  },
  set: ({ set }, newValue: number) => {
    set(SliderValuePut, newValue);
  },
});

/**切换滑杆的百分比 */
export const sliderPercent = atom<number>({
  key: "slider-percent-values",
  default: 0,
});

/**
 * 涨跌幅百分比 可以有负数  如100% 数值为100
 */
export const SelectPercent = selector<number>({
  key: "select-percent-values",
  get: ({ get }) => {
    return get(sliderPercent);
  },
  set: ({ set }, state) => {
    set(sliderPercent, state);
  },
});
/**通道上限 */
export const configurePriceUpr = atom<number>({
  key: "config-values-up",
  default: 0,
});

//选择的上限
export const SelectUper = selector<any>({
  key: "select-up-config",
  get: ({ get }) => {
    let configUp = get(configurePriceUpr);
    const defaultVal = get(MixSelectTicker);
    const chooseType = get(SelecedTradeType);
    const priceType = get(SelectedPriceType);
    const EditDatas = get(EditData);
    const optionTypes = get(optionType);
    if (!configUp) {
      //新增
      if (optionTypes === OPERATION_TYPE.ADD) {
        //合约
        if (chooseType === TRADE_TYPE.FUTURES) {
          if (priceType === PRICE_TYPE.MARKET) {
            configUp = defaultVal?.price;
          }
          if (priceType === PRICE_TYPE.MARK) {
            configUp = defaultVal?.markPrice;
          }
          if (priceType === PRICE_TYPE.INDEX_PRICE) {
            configUp = defaultVal?.indexPrice;
          }
          // configUp = priceType === PRICE_TYPE.MARKET ? defaultVal?.price : defaultVal?.markPrice
        }
        //现货
        if (chooseType === TRADE_TYPE.SPOT) {
          configUp = defaultVal?.price;
        }
      } else {
        //编辑
        configUp = EditDatas?.configurePriceUp;
      }
    }
    return isNil(configUp) ? 0 : +configUp;
  },
  set: ({ set }, state) => {
    set(configurePriceUpr, state);
  },
});
export const configurePriceDown = atom<number>({
  key: "config-values-down",
  default: 0,
});

//选择的下限
export const SelectDown = selector<any>({
  key: "select-down-config",
  get: ({ get }) => {
    let configDown = get(configurePriceDown);
    const EditDatas = get(EditData);
    const optionTypes = get(optionType);
    if (!configDown) {
      if (optionTypes === OPERATION_TYPE.ADD) {
        configDown = get(MixSelectTickerPrice);
      } else {
        configDown = EditDatas?.configurePriceDown;
      }
    }
    return isNil(configDown) ? 0 : +configDown;
  },
  set: ({ set }, state) => {
    set(configurePriceDown, state);
  },
});

export const gPlateExpandLastList = atom({
  key: "global-plate-expand-lastlist",
  default: [],
});
/**
 * 价格提醒更新次数 用于触发Alert log 重新请求 不可做精准统计
 */
export const AlertUpdateTimes = atom<number>({
  key: "alert-update-times",
  default: 0,
});

/**
 * 滑杆Setting接口返回的数据
 */
export const SliderSettingData = atom<any>({
  key: "get-setting-data",
  default: {},
});

/**
 * 价格提醒用户偏好数据
 */
export const PriceAlertUserPreferenceState = atom<UserPreferenceSetting>({
  key: "price-alert-user-preference-state",
  default: {} as UserPreferenceSetting,
});

/**
 * 价格提醒频率参数
 */
export const FrequencyParameterState = atom<FrequencyParameter>({
  key: "frequency-parameter-state",
  default: {
    inSecond: 1,
    frequencys: 2,
    perHour: 2,
    perDay: 2,
    businessLineLimit: 20,
    totalLimit: 50,
  } as FrequencyParameter,
});

/**
 * 价格提醒日志列表
 */
export const PriceAlertLogListState = selector({
  key: "price-alert-log-list-state",
  get: async ({ get }) => {
    try {
      const isLogin = get(LoginSelector);
      const tradeTyoe = get(SelecedTradeType);
      if (!isLogin) return [];
      const res: any = await getAlertLogListApi({
        businessLine: tradeTyoe,
      });
      return res?.data?.length > 0 ? res?.data : [];
    } catch (error) {
      return [];
    }
  },
});

//是否展示价格提醒红点
export const PriceAlertRedDotState = atom({
  key: "price-alert-red-dot-state",
  default: false,
});

//合约币对列表-取自接口
export const FuturesSymbolListState = atom({
  key: "futures-ticker-list-state",
  default: [],
});

//现货币对列表-取自接口
export const SpotSymbolListState = atom({
  key: "spot-ticker-list-state",
  default: [],
});
